import useMediaQuery from "@mui/material/useMediaQuery";

export const useResponsive = () => {
  const isXs = useMediaQuery("(max-width:639.95px)");
  const isSm = useMediaQuery("(min-width:640px) and (max-width:767.95px)");
  const isMd = useMediaQuery("(min-width:768px) and (max-width:1199.95px)");
  const isLg = useMediaQuery("(min-width:1200px) and (max-width:1535.95px)");
  const isXl = useMediaQuery("(min-width:1536px)");

  let activeBreakpoint: "xs" | "sm" | "md" | "lg" | "xl" = "xs";
  if (isXl) activeBreakpoint = "xl";
  else if (isLg) activeBreakpoint = "lg";
  else if (isMd) activeBreakpoint = "md";
  else if (isSm) activeBreakpoint = "sm";

  return { isXs, isSm, isMd, isLg, isXl, activeBreakpoint };
};
